import React, { useMemo, useState } from "react";
import {
  LayoutDashboard,
  ShieldCheck,
  FileText,
  User,
  LogOut,
  PlusCircle,
  CheckCircle2,
  AlertTriangle,
} from "lucide-react";
import OverviewView from "./OverviewView";
import WarrantyView from "./WarrantyView";
import LegalView from "./LegalView";
import ProfileView from "./ProfileView";

// Mock logged-in user (retailer staff)
const currentUser = {
  id: 21,
  name: "Sanjay (Owner)",
  role: "Retailer Admin",
  mobile: "+91 98765 00001",
  email: "owner@retailer.com",
  storeName: "Shree Mobile Store",
  location: "Pune, Maharashtra",
  joinedOn: "2024-03-10",
};

// Mock warranties created by this user
const initialWarranties = [
  {
    id: "WAR-U-1001",
    invoiceNo: "INV-2025-001",
    productName: "POS Terminal Basic",
    imei: "356789012345678",
    purchaseDate: "2025-08-15",
    registeredOn: "2025-10-01",
    status: "Approved", // Pending | Approved | Rejected
    issueType: "Device not powering on",
    registeredBy: currentUser.name,
    adminRejectReason: "",
  },
  {
    id: "WAR-U-1002",
    invoiceNo: "INV-2025-002",
    productName: "mPOS Wireless",
    imei: "352345678901234",
    purchaseDate: "2025-09-01",
    registeredOn: "2025-10-12",
    status: "Rejected",
    issueType: "Physical damage",
    registeredBy: currentUser.name,
    adminRejectReason: "Liquid damage not covered under warranty",
  },
  {
    id: "WAR-U-1003",
    invoiceNo: "INV-2025-004",
    productName: "Soundbox Pro",
    imei: "351234567890123",
    purchaseDate: "2025-10-20",
    registeredOn: "2025-11-01",
    status: "Pending",
    issueType: "Speaker low volume",
    registeredBy: currentUser.name,
    adminRejectReason: "",
  },
];


function RetailerUserDashboard() {
  const [view, setView] = useState("overview"); // overview | warranty | legal | profile
  const [warranties, setWarranties] = useState(initialWarranties);

  const [form, setForm] = useState({
    invoiceNo: "",
    productName: "",
    imei: "",
    purchaseDate: "",
    issueType: "",
  });

  const [submitting, setSubmitting] = useState(false);

  const warrantyStats = useMemo(() => {
    const total = warranties.length;
    const approved = warranties.filter((w) => w.status === "Approved").length;
    const rejected = warranties.filter((w) => w.status === "Rejected").length;
    const pending = warranties.filter((w) => w.status === "Pending").length;
    return { total, approved, rejected, pending };
  }, [warranties]);

  const handleSubmitWarranty = (e) => {
    e.preventDefault();
    if (
      !form.invoiceNo ||
      !form.productName ||
      !form.imei ||
      !form.purchaseDate ||
      !form.issueType
    ) {
      alert("Please fill all warranty fields.");
      return;
    }
    setSubmitting(true);

    const newWarranty = {
      id: `WAR-U-${1000 + warranties.length + 1}`,
      invoiceNo: form.invoiceNo,
      productName: form.productName,
      imei: form.imei,
      purchaseDate: form.purchaseDate,
      registeredOn: new Date().toISOString().slice(0, 10), // yyyy-mm-dd
      status: "Pending",
      issueType: form.issueType,
      registeredBy: currentUser.name,
      adminRejectReason: "",
    };

    setTimeout(() => {
      setWarranties((prev) => [newWarranty, ...prev]);
      setForm({
        invoiceNo: "",
        productName: "",
        imei: "",
        purchaseDate: "",
        issueType: "",
      });
      setSubmitting(false);
    }, 400);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 via-blue-50 to-slate-100 flex flex-col text-slate-900">
      {/* Top bar */}
      {/* <header className="bg-white/90 backdrop-blur border-b border-slate-200/80 px-4 md:px-6 py-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-9 h-9 rounded-2xl bg-blue-600 text-white text-sm font-semibold">
            {currentUser.name.charAt(0)}
          </div>
          <div>
            <div className="text-xs text-slate-500 uppercase tracking-wide">
              Retailer User Dashboard
            </div>
            <div className="text-sm md:text-base font-semibold text-slate-800 flex items-center gap-2">
              <User className="w-4 h-4 text-blue-600" />
              <span>{currentUser.name}</span>
              <span className="hidden sm:inline text-[11px] px-2 py-0.5 rounded-full bg-blue-50 text-blue-700 border border-blue-100">
                {currentUser.role}
              </span>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className="hidden md:inline text-[11px] text-slate-500">
            Store: <span className="font-medium">{currentUser.storeName}</span>
          </span>
          <button className="inline-flex items-center gap-1 text-[11px] px-2.5 py-1.5 rounded-lg border border-slate-200 bg-slate-50 hover:bg-slate-100 text-slate-700">
            <LogOut className="w-3 h-3" />
            <span>Logout</span>
          </button>
        </div>
      </header> */}

      {/* Nav tabs */}
      {/* <nav className="px-4 md:px-6 pt-3">
        <div className="flex rounded-2xl bg-white/70 border border-slate-200/80 p-1 text-[11px] font-medium overflow-x-auto">
          {[
            // { id: "overview", label: "Overview", icon: LayoutDashboard },
            { id: "warranty", label: "Warranty", icon: ShieldCheck },
            { id: "legal", label: "Legal & Consents", icon: FileText },
            { id: "profile", label: "Profile", icon: User },
          ].map((tab) => {
            const Icon = tab.icon;
            const active = view === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => setView(tab.id)}
                className={`flex items-center gap-1 px-3 py-1.5 rounded-2xl whitespace-nowrap mr-1 last:mr-0 ${
                  active
                    ? "bg-blue-600 text-white shadow-sm"
                    : "text-slate-700 hover:bg-slate-100"
                }`}
              >
                <Icon className="w-3 h-3" />
                <span>{tab.label}</span>
              </button>
            );
          })}
        </div>
      </nav> */}

      {/* Content */}
      <main className="flex-1 px-4 md:px-6 py-4">
        {view === "overview" && (
          <OverviewView
            warrantyStats={warrantyStats}
            lastWarranty={warranties[0]}
          />
        )}

        {/* {view === "warranty" && (
          <WarrantyView
            warranties={warranties}
            form={form}
            setForm={setForm}
            submitting={submitting}
            onSubmit={handleSubmitWarranty}
          />
        )} */}

        {/* {view === "legal" && <LegalView />}

        {view === "profile" && <ProfileView currentUser={currentUser} />} */}
      </main>
    </div>
  );
}

export default RetailerUserDashboard;
